/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Create_Private_Threads_HintInputs */



/**
* | output |
* | --- |
* | "Allow members to create invite-only threads." |
*
* @param {Leveling_Perm_Create_Private_Threads_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_create_private_threads_hint = /** @type {((inputs?: Leveling_Perm_Create_Private_Threads_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Create_Private_Threads_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам создавать ветки, куда попадают только по приглашению.")
	return /** @type {LocalizedString} */ ("Allow members to create invite-only threads.")
});